import React, { useEffect, useState } from 'react';

import { FormSectionGlobal as FormSection } from '@fitinsur/components';
import { Row, Col } from "components/Grid";
import DocumentTagList from '@fitinsur/components/DocumentTagList';

import { PolicyWordingSection } from '../index';

function RenderSection({
  disableAll,
  formikProps,
  formikRef,
  idProduct,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  documentsToDelete,
  setDocumentsToDelete,
  authContext,
}) {
  return (
    <>
      <FormSection
        disableAll={disableAll}
        sectionName="POLICY_WORDING"
        errors={formikProps.errors}
        questionnaire={globalQuestionnaire}
        setQuestionnaire={setGlobalQuestionnaire}
        values={formikProps.values}
        setFieldValue={formikProps.setFieldValue}
        setFieldError={formikProps.setFieldError}
        formikRef={formikRef}
        idOperation={idOperation}
        idOperationParent={idOperationParent}
        idProduct={idProduct}
        isSelectMarketsScreen
        disableAutoUpload
        // onQuestionChange={(question, value, setFieldValue, questionnaireUpdated) =>
        //   PolicyWordingSection.events.handleQuestionChange({
        //     question,
        //     value,
        //     questionnaireUpdated,
        //     setQuestionnaire: setGlobalQuestionnaire,
        //     setFieldValue,
        //     questionnaireAnswersToDelete,
        //     setQuestionnaireAnswersToDelete,
        //     documentsToDelete,
        //     setDocumentsToDelete
        //   })
        // }
      />

      <DocumentTagList
        idQuestion={1941}
        questionnaire={globalQuestionnaire}
        setQuestionnaire={setGlobalQuestionnaire}
        removeDocument={(questionnaireUpdated) => {
            setGlobalQuestionnaire(questionnaireUpdated);
        }}
        showRemoveIcon
        idOperation={idOperation}
        authContext={authContext}
      />

      <label 
        style={{
          padding: "24px 0 8px 0"
        }}
      >
        Note: Policy wording for declaration WILL NOT be signed or scratched again
      </label>
    </>
  )
}

const components = {
  RenderSection
}

export { components }